import { createRouter, createWebHistory } from 'vue-router'
import Start from '@/components/Public/Start'
import { canAccessRoute, ROLES } from '@/utils/rolePermissions'

const routes = [
  { path: '/', name: 'Start', component: Start, meta: { requiresAuth: false } },
  { path: '/privacy', name: 'Privacy Policy', component: () => import('@/components/Public/PrivacyPolicy'), meta: { requiresAuth: false } },
  { path: '/user', name: 'User', component: () => import('@/components/User/Dashboard'), meta: { requiresAuth: true } },
  { path: '/calendar', name: 'Calendar', component: () => import('@/components/Calendar/Calendar'), meta: { requiresAuth: true } },
  { path: '/lesson', name: 'Lesson List', component: () => import('@/components/Lesson/LessonList'), meta: { requiresAuth: true } },
  { path: '/lesson/:id', name: 'Lesson View', component: () => import('@/components/Lesson/LessonView'), meta: { requiresAuth: true } },
  { path: '/student', name: 'List Student', component: () => import('@/components/Student/StudentList'), meta: { requiresAuth: true } },
  { path: '/student/:id', name: 'View Student', component: () => import('@/components/Student/StudentView'), meta: { requiresAuth: true } },
  { path: '/staff', name: 'Staff List', component: () => import('@/components/Staff/StaffList'), meta: { requiresAuth: true } },
  { path: '/staff/:id', name: 'View Staff', component: () => import('@/components/Staff/StaffView'), meta: { requiresAuth: true } },
  { path: '/dashboard', name: 'User Dashboard', component: () => import('@/components/Reports/ReportsView'), meta: { requiresAuth: true, isAdmin: true } },
  { path: '/settings', name: 'Settings', component: () => import('@/components/Settings/SettingsList'), meta: { requiresAuth: true } },
  { path: '/admin', name: 'Admin Dashboard', component: () => import('@/components/Administration/AdminDashboard'), meta: { requiresAuth: true, isMaster: true } },
  { path: '/works', name: 'Work List', component: () => import('@/components/Work/WorkList'), meta: { requiresAuth: true } },
  { path: '/equipment', name: 'Equipment List', component: () => import('@/components/Equipment/EquipmentList'), meta: { requiresAuth: true } },
  { path: '/transport', name: 'Transport List', component: () => import('@/components/Transport/TransportList'), meta: { requiresAuth: true } },
  { path: '/transport/:id', name: 'Transport View', component: () => import('@/components/Transport/TransportView'), meta: { requiresAuth: true } },
  { path: '/packages', name: 'Package List', component: () => import('@/components/PackageService/PackageList'), meta: { requiresAuth: true } },
  { path: '/package/:id', name: 'Package View', component: () => import('@/components/PackageService/PackageView'), meta: { requiresAuth: true } },
  { path: '/services', name: 'Service List', component: () => import('@/components/PackageService/ServiceList'), meta: { requiresAuth: true } },
  { path: '/item', name: 'Item List', component: () => import('@/components/Item/ItemList'), meta: { requiresAuth: true } },
  { path: '/eventtypes', name: 'Event Types List', component: () => import('@/components/LessonType/LessonTypeList'), meta: { requiresAuth: true } },
  { path: '/lessontypes', name: 'Lesson Types List', component: () => import('@/components/LessonType/LessonTypeList'), meta: { requiresAuth: true } },
  { path: '/supplier', name: 'Supplier List', component: () => import('@/components/Supplier/SupplierList'), meta: { requiresAuth: true } },
  { path: '/room', name: 'Room List', component: () => import('@/components/Room/RoomList'), meta: { requiresAuth: true } },
  { path: '/room/:id', name: 'Room View', component: () => import('@/components/Room/RoomView'), meta: { requiresAuth: true } },
  { path: '/place', name: 'Place List', component: () => import('@/components/Place/PlaceList'), meta: { requiresAuth: true } },
  { path: '/chatbot', name: 'SmartBot', component: () => import('@/components/SmartBot/General'), meta: { requiresAuth: true } },

  { path: '/help', name: 'Help', component: () => import('@/components/General/Help'), meta: { requiresAuth: true } },
  {
    path: '/:pathMatch(.*)*', name: 'NotFound', component: Start,
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

router.beforeEach((to, from, next) => {
  const store = require('@/store').default
  const user = store.state.email
  
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (!user || user === '') {
      next({ path: '/', params: { nextUrl: to.fullPath } })
    } else {
      try {
        const userProfile = store.state.profile;

        // Handle User role - restricted to user dashboard and help only
        if (userProfile === ROLES.USER && to.path !== '/user' && to.path !== '/help') {
          next({ path: '/user' });
          return;
        }

        // Check route access using centralized permissions
        if (!canAccessRoute(userProfile, to.name)) {
          // Redirect to appropriate default route based on role
          const defaultRoutes = {
            [ROLES.INSTRUCTOR]: '/chatbot',
            [ROLES.MANAGER]: '/chatbot', 
            [ROLES.ADMINISTRATOR]: '/chatbot',
            [ROLES.MASTER]: '/chatbot'
          };
          next({ path: defaultRoutes[userProfile] || '/chatbot' });
          return;
        }

        next();
      } catch (error) {
          console.log(error)
        const rememberedEmail = localStorage.getItem('rememberedEmail')
        localStorage.clear()
        if (rememberedEmail) {
          localStorage.setItem('rememberedEmail', rememberedEmail)
        }
        next({ path: '/', params: { nextUrl: to.fullPath } })
      }
    }
  } else {
    next()
  }
})

export default router